import '../../node_modules/bootstrap/dist/js/bootstrap.min';
import '../../js/remove-paragraph-from-headers.jsx';
import '../../components/navbar/navbar.jsx';
import '../../js/event-goal-push.jsx';
import '../../js/type-writter.jsx';
import './service.scss';
